import CreativeType from '@/Enums/Creatives/CreativeType.enum';
import AudioPlayer from '@/components/AudioPlayer';
import type { InlineCreativeType } from '@/types/creativeLibrary';
import { Modal } from '@mui/material';
import classNames from 'classnames';
import { useState } from 'react';

interface IProps {
  format: InlineCreativeType;
  src: string;
  className?: string;
}

const FilePreview = ({ format, src, className }: IProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  switch (format) {
    case CreativeType.VIDEO:
      return (
        <video controls className={classNames('w-full', className)}>
          <source src={src} type={'video/mp4'} />
          Your browser does not support the video tag.
        </video>
      );
    case CreativeType.DISPLAY:
      return isExpanded ? (
        <Modal open={isExpanded}>
          <img
            className='object-contain w-full h-full fixed top-0 left-0 cursor-pointer'
            src={src}
            alt='thumbnail'
            onClick={toggleExpand}
          />
        </Modal>
      ) : (
        <img
          className={classNames('object-contain cursor-pointer', className)}
          src={src}
          alt='thumbnail'
          onClick={toggleExpand}
        />
      );
    case CreativeType.AUDIO:
      return <AudioPlayer src={src} />;
    default:
      return <p className='font-semibold'>Preview not available</p>;
  }
};

export default FilePreview;
